import React from 'react';
import Button from '../Button/Button';
import { reloadPage } from '../../utilities/helpers/common';
import { Phrases } from '../../utilities/constants/phrases';

const AppError: React.FC = () => (
  <div className='ta-center mt-md mb-md'>
    <h2 className='mb-xxxs'>{Phrases.APP_ERROR_TITLE}</h2>
    <p className='c-main-light mb-xs'>{Phrases.APP_ERROR_DESCRIPTION}</p>
    <Button onClick={reloadPage}>{Phrases.APP_ERROR_RELOAD_BUTTON}</Button>
  </div>
);

export default AppError;
